// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import */
 
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { PageNotFound } from 'app/components/page-not-found';
import { SystemHeader, SystemIcon } from 'app/components/shared/system-header';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasReadAccessToMasterConfigSubSystem, canViewFareMediaBatches as canViewFareMediaBatchesSelector } from 'selectors';
import { Merchants } from 'app/cards-management/merchants';
import { MerchantPOS } from './merchant-pos';
import { ChargingTransactions } from './charging-transactions';
import { FareMedia } from './fare-media';
import { TransferBalance } from './transfer-balance';
import { FareMediaBatches } from './fare-media-batches';
import { Users } from './users';
const CardsManagement: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);
  const intl = useIntl();
  const canViewMerchants = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'Merchants')
  );
  const canViewMerchantPOS = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'MerchantPOS')
  );
  const canViewChargingTransactions = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'ChargingTransactions')
  );
  const canViewFareMedia = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'FareMedia')
  );
    const canViewTransferBalance = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'TransferBalance')
  );
  const canViewFareMediaBatches = useTypedSelector(state =>
    canViewFareMediaBatchesSelector(state)
  );
  const canViewUsers = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'Users')
  );

  const getInitialRoute = () => {
    if (canViewMerchants) {
      return `${baseURL}/merchants`;
    }
    if (canViewMerchantPOS) {
      return `${baseURL}/merchantPOS`;
    }
    if (canViewChargingTransactions) {
      return `${baseURL}/chargingTransactions`;
    }
    if (canViewFareMedia) {
      return `${baseURL}/fareMedia`;
    }
    if (canViewTransferBalance) {
      return `${baseURL}/transferBalance`;
    }
    if (canViewFareMediaBatches) {
      return `${baseURL}/fare-media-batches`;
    }
    return `${baseURL}/merchants`;
  };

  return (
    <>
      <SystemHeader
        headerTitle={intl.formatMessage({ id: 'CardsManagement' })}
        headerIcon={SystemIcon.CardsManagement}
      />

      <Switch>
        <Redirect from={baseURL} exact to={getInitialRoute()} />

        <Route path={`${baseURL}/merchants`}>
          {canViewMerchants ? <Merchants /> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/merchantPOS`}>
          {canViewMerchantPOS ? <MerchantPOS /> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/chargingTransactions`}>
          {canViewChargingTransactions ? <ChargingTransactions /> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/fareMedia`}>
          {canViewFareMedia ? <FareMedia /> : <NotAuthorized />}
        </Route>
           <Route path={`${baseURL}/transferBalance`}>
          {canViewTransferBalance ? <TransferBalance /> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/fare-media-batches`}>
          {canViewFareMediaBatches ? <FareMediaBatches /> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/users`}>
          {canViewUsers ? <Users /> : <NotAuthorized />}
        </Route>

        <Route path="/">
          <PageNotFound />
        </Route>
      </Switch>
    </>
  );
};

export { CardsManagement };
